import { SearchModel } from './common';

/**
 * Tipos para Invalidação (Inutilização) de Notas Fiscais NF-e/NFC-e
 * conforme documentado em ERPApi/docs/funcionalidades/notas-fiscais/inutilizacao-e-comunicacao-sefaz.md
 *
 * Endpoints:
 *   POST /api/v1/invoice-invalidations
 *   GET  /api/v1/invoice-invalidations
 *   GET  /api/v1/invoice-invalidations/{id}
 *
 * Restrição: requer papel `admin` no token (validação via permissão
 * invoice_invalidation.read / invoice_invalidation.create no front).
 */

// ─── Status ──────────────────────────────────────────────────────

export const INVOICE_INVALIDATION_STATUS_OPTIONS = [
  { value: 1, label: 'Pendente', color: 'yellow' },
  { value: 2, label: 'Homologado', color: 'emerald' },
  { value: 3, label: 'Rejeitado', color: 'red' },
] as const;

export type InvoiceInvalidationStatusId = 1 | 2 | 3;

export const getInvoiceInvalidationStatusLabel = (status?: number | null): string => {
  if (status === null || status === undefined) return '—';
  return (
    INVOICE_INVALIDATION_STATUS_OPTIONS.find((o) => o.value === status)?.label ?? String(status)
  );
};

// ─── Entidade ────────────────────────────────────────────────────

export interface InvoiceInvalidation {
  invalidation_id: number;
  company_id: number;
  company_name?: string | null;
  company_document?: string | null;
  model: number;
  serie: number;
  number_start: number;
  number_end: number;
  justification: string;
  protocol_number?: string | null;
  status_id: number;
  status_name?: string | null;
  sefaz_log_id?: number | null;
  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
}

// ─── Payloads ────────────────────────────────────────────────────

export interface InvoiceInvalidationCreatePayload {
  company_id: number;
  /** Ano com 2 dígitos (AA) — ex.: 26 = 2026 */
  year: number;
  /** Modelo fiscal — 55 (NF-e) ou 65 (NFC-e). Default 55 quando omitido. */
  model?: number;
  serie: number;
  number_start: number;
  number_end: number;
  justification: string;
}

// ─── Filtros ─────────────────────────────────────────────────────

export interface InvoiceInvalidationListFilters extends SearchModel {
  company_id?: number;
  date_from?: string;
  date_to?: string;
  status_id?: number;
}

export interface InvoiceInvalidationListResult {
  data: InvoiceInvalidation[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}
